import {
  AutomationTypeEnum,
  Fee,
  FormSpec,
  Region,
  RequirementEta,
} from '../../../types';

// TODO: Move this to types/api.ts once we have the final API response types

type TaskContextEmployee = {
  scope: 'employee';
  employee_id: string;
};

type TaskContextLegalEntity = {
  scope: 'legal-entity';
  legal_entity_id: string;
};

export enum TaskCategory {
  HR = 'hr',
  Insurance = 'insurance',
  Payroll = 'payroll',
  Registration = 'registration',
  RegistrationMaintenance = 'registration-maintenance',
  Tax = 'tax',
}

export type Resource = {
  name: string;
  url: string;
};

export type LocationRef = {
  id: string;
  code: string;
  name: string;
};

export type TaskPathType = 'link' | 'mail' | 'phone' | 'fax' | 'email';

type TaskRemediationPath = {
  type: TaskPathType;
  value: string;
  text: string | null;
};

export type TaskRemediation = {
  id: string;
  title: string;
  description: string;
  order: number;
  paths: TaskRemediationPath[];
};

type TaskManagedProvider = {
  id: string;
  name: string;
};

export enum TaskStatus {
  Todo = 'todo',
  InProgress = 'in-progress',
  Done = 'done',
}

export enum TaskType {
  Requirement = 'requirement',
  Question = 'question',
}

export type TaskSourceRequirement = {
  type: TaskType.Requirement;
  id: string;
  context: TaskContextEmployee | TaskContextLegalEntity;
  requirement_id: string;
  title: string;
  summary: string | null;
  description: string;
  category: TaskCategory;
  is_setup: boolean;
  is_automatable: boolean;
  resources: Resource[];
  tags: AutomationTypeEnum[];
  remediations: TaskRemediation[];
  managed_provider: TaskManagedProvider | null;
  period_start_date: string | null;
  period_end_date: string | null;
  due_date: string | null;
  fee: Fee | null;
  eta: RequirementEta | null;
  indications: string[];
  location: LocationRef;
};

export type TaskSourceQuestion = {
  type: TaskType.Question;
  locations: LocationRef[];
  form: FormSpec;
  answer: string | null;
};

export type UserRef = {
  id: string;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
};

export interface BaseTask {
  id: string;
  title: string;
  status: TaskStatus;
}

export interface Task extends BaseTask {
  assigned_user: UserRef | null;
  source: TaskSourceQuestion | TaskSourceRequirement;
}

export interface TaskQuestion extends Task {
  source: TaskSourceQuestion;
}

export interface TaskRequirement extends Task {
  source: TaskSourceRequirement;
}

export interface TaskQuestionRef {
  type: TaskType.Question;
  locations: LocationRef[];
  answer: string | null;
}

export interface TaskRequirementRef {
  type: TaskType.Requirement;
  location: LocationRef;
}

export interface TaskRef extends BaseTask {
  source: TaskQuestionRef | TaskRequirementRef;
}

export interface TasksAlert {
  region: Region | null;
  is_setup: boolean;
  tasks: TaskRef[];
}

export interface TasksLocation {
  region: Region | null;
  employee_count: number | null;
  tasks: TaskRef[];
}

export interface TaskSummary {
  alerts: TasksAlert[];
  locations: TasksLocation[];
}
